import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import TalukModel from "../../models/masters/taluk-model";


const url = getEndPoint(API_END_POINT.MASTER) +"/api/Taluk/GetAllTaluk";// //{/api/Taluk/GetAllTaluk}`)  //// "https://localhost:7054/api/Taluk/GetAllTaluk";
export const useGetTaluks = createQuery<
  TalukModel[],
  null,
  AxiosError
>({
  queryKey: ["keyTaluklist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});